interface BookSelectionStepHeadingProps {
    title: string;
    hint?: string;
}

const BookSelectionStepHeading = (props: BookSelectionStepHeadingProps) => (
    <div className="flex flex-col gap-xxs">
        <h3 className="m-no text-xl font-semibold text-p6-grey-dark">{props.title}</h3>
        {props.hint && <p className="m-no text-m text-p6-grey-dark">{props.hint}</p>}
    </div>
);

export default BookSelectionStepHeading;
